import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'

export default {
  /**
   * @returns {Promise}
   */
  /**
   * @returns {Promise}
   */
  getEmodnetDepthProfile(geom:string):AxiosPromise<Array<number>> {            
    return apiHelpers.externalApiCall({ 
      url: 'https://rest.emodnet-bathymetry.eu/depth_profile', 
      method: 'GET', 
      params: {geom},
      transformResponse: [function (data:string) {               
        return JSON.parse(data) as Array<number>        
      }]
    })    
  }
}